import { AdminProctorDetailsPermissionUpdate } from '@exam-center/admin-proctor-details';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Flex } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function AdminProctorDetailsPage() {
  return (
    <PermissionGuard requiredPermission={[APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR.VIEW]}>
      <Flex
        sx={(theme) => ({
          flex: 1,
          gap: theme.spacing(6),
          flexDirection: 'column',
        })}
      >
        <AdminProctorDetailsPermissionUpdate />
      </Flex>
    </PermissionGuard>
  );
}
